import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Stack, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import JsFileDownloader from 'js-file-download';
import {
  VIEW_COLUMNS,
  LISTING_COLUMNS,
  LISTING_ACTIONS,
} from '../../config/module-configs/manage-recurring-event.config';
import ListData from '../table-elements/list-data.component';
import Iconify from '../common/iconify.component';
import {
  deleteRecurringEventById,
  getEventRegistrationByVideoId,
  getRecurringEventsList,
} from '../../services/content.service';
import ROUTE_PATH from '../../config/routes.config';
import Loading from '../table-elements/loading.component';
import ViewData from '../table-elements/view-data.component';
import { ACTIONS, CONTENT_ALIAS, PAID_TYPE } from '../../config/const.config';
import UploadRecurringEventAssets from './upload-recuring-event-assets.component';
import Translate from './translate-recuring-poster.component';
import ConfirmPopup from '../common/confirm-popup.component';

const ManageRecurringEvent = ({ id }) => {
  const viewColumns = VIEW_COLUMNS;
  const listColumns = LISTING_COLUMNS;
  const actions = LISTING_ACTIONS;
  const [viewData, setViewData] = useState(null);
  const [isRecurring, setIsRecurring] = useState(null);
  const [loading, setLoading] = useState(true);

  const renderActions = [];
  actions.forEach((item) => {
    renderActions.push(item);
  });

  const [options, setOptions] = useState({
    page: 0,
    rowsPerPage: 10,
    totalRows: 0,
    rows: [],
    reloadCounter: 0,
    sortBy: '',
    sortOrder: '',
    error: false,
    loading: true,
  });
  const [doAction, setDoAction] = useState({
    data: null,
    action: null,
  });
  const [snackbarInfo, setSnackbarInfo] = useState({
    show: false,
    type: '',
    message: '',
  });
  const [roptions, setrOptions] = useState({
    page: 0,
    rowsPerPage: 10,
    totalRows: 0,
    rows: [],
    reloadCounter: 0,
    sortBy: '',
    sortOrder: '',
    error: false,
    loading: true,
  });
  const [imagePreview, setImagePreview] = useState({
    show: false,
    imageUrl: '',
    title: '',
  });
  const handleLoading = () => {
    setLoading(false);
  };
  const handleActionSelect = (selectedAction, selectedData) => {
    setSnackbarInfo({
      ...snackbarInfo,
      show: false,
    });

    setDoAction({
      ...doAction,
      data: selectedData || null,
      action: selectedAction || null,
    });
  };
  const handleRefreshData = () => {
    setOptions({
      ...options,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleActionCancel = () => {
    setDoAction({
      ...doAction,
      data: null,
      action: null,
    });

    setImagePreview({
      ...imagePreview,
      show: false,
    });
  };
  const handleActionSuccess = (message = '') => {
    if (message) {
      setSnackbarInfo({
        ...snackbarInfo,
        show: true,
        type: 'success',
        message,
      });
    }

    handleActionCancel();
    handleRefreshData();
  };
  const handleDeleteData = () => {
    setSnackbarInfo({
      ...snackbarInfo,
      show: false,
    });

    deleteRecurringEventById(doAction.data.id)
      .then(() => {
        handleActionSuccess(
          `${CONTENT_ALIAS.VIDEO_SINGULAR} deleted successfully.`
        );
        handleActionCancel();
      })
      .catch((e) => {
        const message =
          e.response?.data?.message ||
          'Something went wrong, please try again.';

        setSnackbarInfo({
          ...snackbarInfo,
          show: true,
          type: 'error',
          message,
        });
        handleActionCancel();
      });
  };

  const handlePageChange = (v) => {
    setOptions({
      ...options,
      page: v,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const handleImagePreview = (rowData) => {
    setImagePreview({
      ...imagePreview,
      show: true,
      imageUrl: rowData.thumbnail,
      title: rowData.title,
    });
  };
  const handleRowsPerPageChange = (v) => {
    setOptions({
      ...options,
      rowsPerPage: v,
      page: 0,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };
  const handleSortingChange = (sortBy, sortOrder) => {
    setOptions({
      ...options,
      sortBy,
      sortOrder,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const getRecurringEventsListData = (output = '') => {
    let uri = `/video/${id}/recurring-events/list`;
    uri += `?page=${options.page + 1}`;
    uri += `&perPage=${options.rowsPerPage}`;
    if (options.sortBy && options.sortOrder) {
      uri += `&sortBy=${options.sortBy}`;
      uri += `&sortOrder=${options.sortOrder}`;
    }
    if (options.q) {
      uri += `&q=${options.q}`;
    }
    if (isRecurring) {
      uri += `&isRecurring=${isRecurring}`;
    }

    if (output === '') {
      setLoading(true);
    }

    getRecurringEventsList(uri)
      .then((res) => {
        let serialRow;
        if (output === '') {
          if (res?.data?.rows) {
            serialRow = res.data.rows;
            serialRow = serialRow.map((tr, count) => ({
              ...tr,
              serial: options.page * options.rowsPerPage + count + 1,
            }));
          }
          setrOptions({
            ...options,
            loading: false,
            totalRows: res?.data?.totalRows || 0,
            rows: serialRow || [],
            error: false,
          });
        } else if (output === 'csv') {
          // eslint-disable-next-line no-unused-vars
          const download = new JsFileDownloader(res, 'event_registrations.csv');
        }

        handleLoading();
      })
      .catch(() => {
        setOptions({
          ...options,
          loading: false,
          page: 0,
          totalRows: 0,
          rows: [],
          error: true,
        });
      });
  };

  const getEventRegistration = (output = '') => {
    let uri = `video/${id}/event-registrations`;
    uri += `?page=${options.page + 1}`;
    uri += `&perPage=${options.rowsPerPage}`;
    if (options.sortBy && options.sortOrder) {
      uri += `&sortBy=${options.sortBy}`;
      uri += `&sortOrder=${options.sortOrder}`;
    }
    if (options.q) {
      uri += `&q=${options.q}`;
    }
    if (isRecurring) {
      uri += `&isRecurring=${isRecurring}`;
    }
    if (output === 'csv') {
      uri += '&output=csv';
    }

    if (output === '') {
      setLoading(true);
    }

    getEventRegistrationByVideoId(uri)
      .then((res) => {
        let serialRow;
        if (output === '') {
          if (res?.data?.rows) {
            serialRow = res.data.rows;
            serialRow = serialRow.map((tr, count) => ({
              ...tr,
              serial: options.page * options.rowsPerPage + count + 1,
            }));
          }

          if (res?.data?.detail) {
            setIsRecurring(res?.data?.detail?.isRecurring);
            setViewData({
              ...res.data.detail,
              totalRegistrations: res.data.totalRows,
              totalJoined: res.data.totalJoin,
              isPaid: PAID_TYPE[`${res.data.detail.isPaid}`],
            });
          }
          setOptions({
            ...options,
            loading: false,
            totalRows: res?.data?.totalRows || 0,
            rows: serialRow || [],
            error: false,
          });
        }

        handleLoading();
      })
      .catch(() => {
        setOptions({
          ...options,
          loading: false,
          page: 0,
          totalRows: 0,
          rows: [],
          error: true,
        });
      });
  };

  useEffect(() => {
    getEventRegistration();
    getRecurringEventsListData();
  }, [options.reloadCounter]);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ px: 1, py: 1 }}
      >
        <Stack direction="row" sx={{ marginBottom: 1 }}>
          <Link to={ROUTE_PATH.CONTENT_VIDEOS}>
            <Button
              color="inherit"
              variant="contained"
              startIcon={<Iconify icon="ic:arrow-back" />}
              sx={{ marginRight: '5px' }}
            >
              Back
            </Button>
          </Link>
        </Stack>

        <div>
          <Button
            color="inherit"
            startIcon={<Iconify icon="ic:twotone-refresh" />}
            onClick={handleRefreshData}
            disabled={options.loading}
          >
            Refresh
          </Button>
        </div>
      </Stack>

      <div>
        {options.loading && <Loading />}
        {!options.loading && <ViewData columns={viewColumns} row={viewData} />}
        <div style={{ marginBottom: '20px' }} />
      </div>

      {/* {!options.loading && ( */}
      <Card>
        <ListData
          columns={listColumns}
          rows={roptions.rows}
          page={roptions.page}
          rowsPerPage={roptions.rowsPerPage}
          totalRows={roptions.totalRows}
          loading={loading}
          actions={renderActions}
          error={roptions.error}
          sortBy={roptions.sortBy}
          sortOrder={roptions.sortOrder}
          onPageChange={handlePageChange}
          onAction={handleActionSelect}
          handleImagePreview={handleImagePreview}
          onRowsPerPageChange={handleRowsPerPageChange}
          onSortChange={handleSortingChange}
        />
      </Card>

      {doAction.action === ACTIONS.UPLOAD_ASSETS.value && (
        <UploadRecurringEventAssets
          title={`Upload Assets - ${viewData.title}`}
          dataId={doAction.data.id}
          dataTitle={doAction.data.title}
          onCancel={handleActionCancel}
          onSuccess={handleActionSuccess}
        />
      )}
      {doAction.action === ACTIONS.TRANSLATE.value && (
        <Translate
          title={`Translate ${CONTENT_ALIAS.VIDEO_SINGULAR} Details - ${viewData.title}`}
          dataId={doAction.data.id}
          onCancel={handleActionCancel}
          onSuccess={handleActionSuccess}
        />
      )}
      {doAction.action === ACTIONS.DELETE.value && (
        <ConfirmPopup
          title={`Delete${CONTENT_ALIAS.VIDEO_SINGULAR} Details - ${viewData.title}`}
          message={`Do you want to delete '${viewData.title}' ${CONTENT_ALIAS.VIDEO_SINGULAR}
          You can not undo this action!`}
          onCancel={handleActionCancel}
          onSuccess={handleDeleteData}
        />
      )}
    </>
  );
};

ManageRecurringEvent.propTypes = {
  id: PropTypes.number.isRequired,
};

export default ManageRecurringEvent;
